import FullStoryBase from '@fullstory/react-native';
import {toString} from 'lodash';

import {log} from '/util/logger.util';

// Set this to `true` to enable console logging of FullStory events.
// Do NOT commit that change into the repo.
const LOG_FULLSTORY = false;

export class FullStory {
  backend: any;

  isEnabled: any;

  sessionId: any;

  verbose: any;

  constructor({verbose}: any = {}) {
    this.verbose = verbose;
    this.backend = FullStoryBase;
    this.isEnabled = false;

    this.sessionId = null;
  }

  enable() {
    this.isEnabled = true;
    this.backend.restart();
    if (this.verbose) {
      log('[FullStory] restart');
    }
  }

  initialize() {
    return this.backend.onReady().then((res: any) => {
      // Set {sessionId} to indicate FullStory is ready
      this.sessionId = res.sessionId;
    });
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  trackUserProperties({userId, certification, rank, har}: any) {
    if (!this.isEnabled) {
      // Fullstory is not enabled on App Start
      return null;
    }

    const payload = {
      uid_str: toString(userId),
      coach_certification: toString(certification),
      coach_current_rank: toString(rank),
      coach_highest_rank: toString(har),
    };

    this.backend.setUserVars(payload);

    if (this.verbose) {
      log('[FullStory] Track user properties', payload);
    }
  }

  shutdown() {
    // Shutdown the current session
    this.backend.shutdown();
    this.isEnabled = false;

    if (this.verbose) {
      log('[FullStory] Shutdown');
    }
  }
}

let FullStoryUtilDefaultInstance: any = null;

export const getFullStoryUtilDefaultInstance = () => {
  if (FullStoryUtilDefaultInstance === null) {
    FullStoryUtilDefaultInstance = new FullStory({
      verbose: LOG_FULLSTORY,
    });
  }

  return FullStoryUtilDefaultInstance;
};
